module.exports = __webpack_public_path__ + "img/zhenshu.09403138.jpg";